"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var React = _interopRequireWildcard(require("react"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function SvgComponent(props, svgRef) {
  return (0, _jsxRuntime.jsx)("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), {}, {
    children: (0, _jsxRuntime.jsx)("path", {
      d: "M23.334 20.006c0 .962-.174 1.915-.512 2.815-.9.339-1.854.512-2.816.513h-.012a7.988 7.988 0 01-2.815-.513 7.961 7.961 0 01-.513-2.815v-.013c0-.99.182-1.94.51-2.815a7.95 7.95 0 012.817-.512h.011c.991 0 1.94.181 2.815.512.34.9.513 1.854.513 2.815v.013h.001zm9.815-2.229h-7.783l5.503-5.503a13.398 13.398 0 00-3.144-3.142l-5.503 5.503V6.852a13.368 13.368 0 00-2.215-.185h-.014c-.755 0-1.494.064-2.215.185v7.783l-5.505-5.503c-.606.431-1.175.913-1.7 1.44l-.003.002a13.49 13.49 0 00-1.439 1.7l5.505 5.503H6.852s-.185 1.463-.185 2.218v.01c0 .755.064 1.496.185 2.217h7.785L9.13 27.724a13.402 13.402 0 003.144 3.143l5.503-5.502v7.783c.72.12 1.458.184 2.213.185h.018c.742 0 1.482-.062 2.213-.185v-7.783l5.504 5.504a13.446 13.446 0 001.702-1.44h.001a13.417 13.417 0 001.438-1.702l-5.502-5.504h7.784c.12-.721.184-1.46.184-2.213v-.02c0-.741-.062-1.48-.184-2.212z",
      fill: "#FF4A00",
      fillRule: "nonzero"
    })
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponent);
var _default = ForwardRef;
exports["default"] = _default;
//# sourceMappingURL=Zapier.js.map